import React from "react";
import { useTranslation } from "react-i18next";

import ArrowFooter from "../../img/ArrowFooter";
import IconMaps from "../../img/IconMaps";
import PhonoFooter from "../../img/PhonoFooter";
import {
  ContainerBlock,
  ContainerData,
  ContainerEmail,
  ContainerInfo,
  Text,
  Hr,
  ContainerAddress,
  ContainerText,
  ContainerCrombie,
  TextBotton,
  ContainerScroll,
  A,
} from "./style";
import UseFooter from "./UseFooter";

const Footer = () => {
  const { ScrollToTop } = UseFooter();
  const [t, i18n] = useTranslation("global");
  const lenguageCss = i18n.languages[0];

  return (
    <>
      <ContainerBlock>
        <div onClick={ScrollToTop}>
          <ArrowFooter />
        </div>
      </ContainerBlock>
      <ContainerData>
        <ContainerEmail>
          <ContainerInfo up="true">
            <Text
              mL="true"
              href="https://crombie.dev/work/proode"
              target="_blank"
            >
              www.crombie.dev
            </Text>
            <Text mL="true" href="mailto:info@crombie.dev" target="_blank">
              info@crombie.dev
            </Text>
          </ContainerInfo>
          <div hr="true">
            <Hr />
          </div>

          <ContainerScroll>
            <div>
              <Text
                dir="true"
                href="#business"
                lenguageCss={lenguageCss}
                business="true"
              >
                {t("business.business")}
              </Text>
            </div>
            <div>
              <Text
                dir="true"
                href="#feature"
                lenguageCss={lenguageCss}
                features="true"
              >
                {t("features.features")}
              </Text>
            </div>
            <div>
              <Text dir="true" href="#contact" lenguageCss={lenguageCss}>
                {t("contact.contact")}
              </Text>
            </div>
          </ContainerScroll>
        </ContainerEmail>
        <ContainerAddress>
          <ContainerText maps="true">
            <a
              href="https://www.google.com/maps/place/Crombie.dev/@-31.6460123,-60.7100386,17z/data=!3m1!4b1!4m5!3m4!1s0x95b5a9ae146e478b:0x330edc357b8b3958!8m2!3d-31.646023!4d-60.7078238"
              target="blank"
            >
              <IconMaps />
            </a>

            <div>
              <TextBotton>San Jerónimo 2542 - Planta Baja Oficina 2</TextBotton>
              <p>CP 3000 - Santa Fe, Argentina </p>
            </div>
          </ContainerText>

          <ContainerText smartPhone="true">
            <a target="blank" href="tel:+5403424121195">
              <PhonoFooter />
            </a>

            <div>
              <TextBotton smartPhone="true">+54 0342 - 4121195 </TextBotton>

              <p>{t("Available.Available")}</p>
              <p>UTC -03:00 </p>
            </div>
          </ContainerText>
        </ContainerAddress>
        <ContainerCrombie>
          <p>
            {t("crombie.crombie")}
            <A href="https://crombie.dev/work/proode" target="blank">
              Crombie.dev
            </A>
          </p>
        </ContainerCrombie>
      </ContainerData>
    </>
  );
};

export default Footer;
